<template>
	<div>
		<buttonlist @help="help" @search="search" @reflash="reflash" @exps="exps"  ref="SetBtn"></buttonlist>

		<!-- <el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
			<el-tab-pane :label="$t('getapi[945]')" name="0"> -->
				<!-- <el-table
					:data="dataSet"
					v-loading="loading"
					:highlight-current-row="true"
					show-overflow-tooltip="true"
					border
					stripe
					size="mini"
					:height="tableHeight"
					header-row-class-name="headerclass"
					@selection-change="handleSelectionChange"
					style="width: 100%; margin-top:0px"
				>
					<el-table-column type="selection" v-if="true"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="mp_flag" :label="$t('getapi[2363]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[137]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Qty_on_hand" :label="$t('getapi[3101]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="MeasureUnit" :label="$t('getapi[888]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargo_position" :label="$t('getapi[1957]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargo_Type" :label="$t('getapi[867]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cargo_Group" :label="$t('getapi[1108]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Assist_Qty_on_hand" :label="$t('getapi[2389]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_ASSIST_UNIT" :label="$t('getapi[130]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Part_status" :label="$t('getapi[552]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="commodity_type_NAME" :label="$t('getapi[120]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="part_stuff" :label="$t('getapi[126]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="receive_time" :label="$t('getapi[2100]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="ISSUE_TIME" :label="$t('getapi[2179]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="cost_unit_price" :label="$t('getapi[2248]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="assign_qty" :label="$t('getapi[2184]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Expiry_Date" :label="$t('getapi[225]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="CusPart_ID" :label="$t('getapi[2390]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="CusPart_Name" :label="$t('getapi[2391]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="frozenman" :label="$t('getapi[2392]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="frozentype" :label="$t('getapi[2393]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="items" :label="$t('getapi[2394]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Consumption_Date" :label="$t('getapi[1512]')"></el-table-column>
					<el-table-column show-overflow-tooltip prop="Ice_out_date" :label="$t('getapi[2397]')"></el-table-column>
				</el-table> -->
			<!-- </el-tab-pane> -->
			<ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
			<li style="width: 100%; margin-top:0px">
				<el-table
				:data="dataSet"
				v-loading="loading"
				:highlight-current-row="true"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				:height="tableHeight"
				header-row-class-name="headerclass"
				@selection-change="handleSelectionChange"
				style="width: 100%; margin-top:0px"
				ref="singleTable"
				>
				<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="200"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')" width="80"></el-table-column>
				<el-table-column show-overflow-tooltip prop="avg_qty" :label="$t('getapi[1628]')" align="right" width="200">
					<template slot-scope="scope">
						{{scope.row.avg_qty | thousandth}}
					</template>
				</el-table-column>

				</el-table> 
			</li>
		</ul>
			<!-- <el-row>
				<el-col :span="18">
					<el-pagination
						style="margin-top: 1em"
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="100"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 60px;color: #545c64;font-size: 95%;">表名/视图名称:{{ DbTbNames }}</div>
				</el-col>
			</el-row> -->
		<!-- </el-tabs> -->
		<serce :isVisible="isVisible" queryData="SchQuotationMoqListViewInfo" ref="ser" @getser="serclick"></serce>
	
	
		
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'moqupdate',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight-240,
                maxHeight: this.$windowSize.tableHeight-240,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dialogVisible: false, //时间选择弹框
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 50, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			isShowEdit: false, // 是否显示编辑页面
			tableHeader: [],
			dataDetail: {
				Head: {},
				Lists: []
			}, // 编辑页面数据详情
			PlanTypeArray: [], // 计划类型数组
			isEdit: true, // 是否新增操作
			selectIDList: [],
			selectObj: {
				part_code: '',
				part_version: '',
				exclusively_id: 0,
				shelflife: ''
			},
			copyparam:{
				startMonth:'',
				copyMonth:'',
			},
			btn: {
				//拷贝
				copy: false,
				//删除
				delete: false,
			},
            scrollTop:0,
		};
	},
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.PlanTypeArray = Array.methods.getPlanType();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })

    },
	methods: {
		colsort(){
			let that = this;
			that.$loadviewfields.Fileds('SchQuotationMoqListViewInfo',0,PFileds=>{
			that.tableHeader=PFileds;		
		});	
		},
		sortclick(val){
			if(val==1){
				this.colsort();
			}
		},
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6543]"),this.$t("getapi[17]"));
        },
		//type 1 一览权限 、2 编辑界面权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			let limits=1;
			//that.$refs.SetBtn.SetOneBtnEnable('ctabel',true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 478, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			limits = that.$limits.OperationAuthorityView('plv2', 478, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
			if(limits==-1||limits==1)that.closeAllRightButton();
            else that.btnauthority();
		},
		btnauthority() {
			// let that = this;
			// that.btn.copy = false;
			// that.btn.delete = false;
			// if (that.$limits.authority('plv4', 62, 1) == 1) {
			// 	that.btn.copy = true;
			// } 
			// if (that.$limits.authority('plv4', 93, 1) == 1) {
			// 	that.btn.delete = true;
			// } 
		},
		closeAllRightButton(){
			//let that =this;
			//that.btn.copy = false;
			//that.btn.delete = false;
		},
		changeperiod() {
			let that = this;
			that.$http.urlpost('/Inv/Manager/InvInfoUpdateShelflife', that.selectObj, function(res) {
				if (res.Success == 1) {
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
					that.getView();
				}
				that.dialogVisible = false;
			});
		},
		showdialog() {
			let that = this;
			if (that.selectObj.exclusively_id == 0) {
				that.$message.warning(that.$t('getapi[8623]'));//'请选择一项！'
				return;
			}
			that.dialogVisible = true;
		},
		handleSelectionChange(val) {
		let that = this;
		that.selectIDList=val;
		},
		
		handleSizeChange(val) {
			this.pageSize = val;
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.pageIndex=1;
			that.$refs.ser.clearInput(that.isVisible, 'SchQuotationMoqListViewInfo');
		},
		// 修改表格顺序
		opentable(){
			this.$refs.ctab.clearInputs(true);
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			// let datac = [];
			// for (let i = 0; i < that.queryData.length; i++) {
			// 	datac.push({
			// 		query_Condition: that.queryData[i].query_Condition,
			// 		query_field_type: that.queryData[i].Query_Field_Type,
			// 		query_field_name: that.queryData[i].Query_Field_Name,
			// 		query_sort: that.queryData[i].query_sort,
			// 		row_sign: that.queryData[i].row_sign
			// 	});
			// }
			// let token = JSON.parse(that.userData).token;
			// let data = {
			// 	PageIndex: that.pageIndex,
			// 	PageSize: that.pageSize,
			// 	Param: datac
			// };
			that.$http.urlpost('/Sch/Moq/GetSchMoqList', {}, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.DataContent.length;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
				}
				that.authority();
			});
		},
		// 根据ID获取详情数据
		editInfo(row) {
			let that = this;
			that.isShowEdit = true;
			that.isEdit = true;
			let parm = {
				Code: row.PO_Code,
				List: []
			};
			this.$refs.order.clearInput(this.isShowEdit, parm);
		},
		// 新增
		add() {
			let that = this;
			let datetime = Common.methods.getDatetime()
			that.isEdit = false;
			that.isShowEdit = true;
			that.dataDetail = {
				Head: {},
				Lists: []
			};
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		//按月拷贝成本
		copy(){
			let that = this;
			that.dialogVisible = true;
			
		},
		deleteline(){
			let that = this;
			that.btn.delete = false;
			let token = JSON.parse(that.userData).token;
			let geturl = Common.Url + 'Inv/PartCost/InvPartStdCostDeleteCost?costID='+that.selectIDList[0].Exclusively_Id+'&token=' + token;
			that.$http.gets(geturl, '', function (res) {
			if (res.data.Success == 1) {
				that.$message.success(res.data.Msg);
				that.getView();
			}else{
				that.$message.warning(res.data.Msg);
			}
			that.btn.delete = true;
			});

		},
		// 导出
		exps() {
			let that = this;
			that.loading = true;
			let parm = {
                LangType: that.$processdata.getLang(),
                fromname: that.$t('getapi[6543]')
			}
			that.$http.urlpost('/Sch/Moq/GetSchMoqListExportToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
				that.loading = false;
			});
		},
		// 保存
		save() {
			let that = this;
			let parm = that.dataDetail;
			that.$http.urlpost('/Pur/Requisition/SaveData', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
				}
			});
		},
		//
		editInfo1() {},
		editInfo2() {},
		editInfo3() {}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}

.bbl {
	margin: 0px auto 10px;
	white-space: pre;
	span {
		margin-left: 10px;
		min-width: 70px;
		text-align: left;
		line-height: 20px;
		display: inline-block;
		margin-right: 0px;
	}
}
</style>
